import { render, staticRenderFns } from "./storageos.vue?vue&type=template&id=dcc76394&"
import script from "./storageos.vue?vue&type=script&lang=js&"
export * from "./storageos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports